module.exports = __webpack_public_path__ + "img/our_advantage3.6f6ee3ac.png";